import React, {useEffect, useState} from "react";
import DataTable from 'react-data-table-component';
import {useDispatch, useSelector} from "react-redux";
import {getAllOrders} from "../../redux/actions/orders";
import OrdersListExcel from "./OrdersListExcel";
import HomeCareOrdersListExcel from "./HomeCareOrdersListExcel";
import OrderDetailsExpanded from "./OrderDetailsExpanded";
import {getVendorType} from "../../services/auth";
import Loading from "../../components/Loading";
import FilterOrdersComponent from "./components/FilterOrdersComponent";
import {toast} from "react-toastify";
import {closeOrderSafeCallModal} from "../../redux/actions/modals";
import {makeSafeCallEmpty} from "../../redux/actions/safeCall";
//import OrderDetailsExpanded from "./OrderDetailsExpanded";

const columns = [
    {
        name: '#',
        selector: 'id',
        sortable: false,
        left: true,
        width: '10%'
    },
    {
        name: 'نام مشتری',
        selector: 'customer_contact_name',
        sortable: false,
        left: true,
        width: '10%'
    },
    {
        name: 'وضعیت',
        selector: 'fa_status',
        sortable: false,
        left: true,
        width: '15%'
    },
    /*{
        name: 'status',
        selector: 'status',
        sortable: false,
        left: true,
        width: '10%'
    },
    {
        name: 'sub status',
        selector: 'sub_status',
        sortable: false,
        left: true,
        width: '10%'
    },*/
    {
        name: 'هزینه بدون بیمه',
        selector: 'order_regular_price',
        sortable: false,
        left: true,
        width: '12%'
    },
    {
        name: 'تاریخ ثبت سفارش',
        selector: 'jalali_created_at',
        sortable: false,
        left: true,
        width: '15%'
    },
    {
        name: 'نام خدمت',
        selector: 'prices[0].title',
        sortable: false,
        left: true,
        width: '20%'
    },
    {
        name: 'تعداد خدمت',
        selector: 'prices[0].count',
        sortable: false,
        left: true,
        width: '8%'
    },
    {
        name: 'نام پزشک /پرستار',
        selector: 'meta_data.sampler_name.value',
        sortable: false,
        left: true,
        width: '10%'
    }
];

const columnsDrug = [
    {
        name: '#',
        selector: 'id',
        sortable: false,
        left: true,
        width: '10%'
    },
    {
        name: 'نام مشتری',
        selector: 'customer_contact_name',
        sortable: false,
        left: true,
        width: '10%'
    },
    {
        name: 'وضعیت',
        selector: 'fa_status',
        sortable: false,
        left: true,
        width: '15%'
    },
    {
        name: 'هزینه بدون بیمه',
        selector: 'order_regular_price',
        sortable: false,
        left: true,
        width: '12%'
    },
    {
        name: 'هزینه با بیمه',
        selector: 'order_insurance_price',
        sortable: false,
        left: true,
        width: '12%'
    },
    {
        name: 'تاریخ ثبت سفارش',
        selector: 'jalali_created_at',
        sortable: false,
        left: true,
        width: '15%'
    }
];

const Orders = (props) => {
    const dispatch = useDispatch();
    const vendor_type = getVendorType();
    const {all_orders_success, all_orders_waiting} = useSelector(state => state.orders);
    const [orders, setOrders] = useState([]);
    const [newOrdersParse, setNewOrdersParse] = useState([])
    const [newOrdersExport, setNewOrdersExport] = useState([])
    const [query, setQuery] = useState({
        page: 1,
        per_page: 10,
        query: ""
    });
    useEffect(() => {
        dispatch(getAllOrders(query));
    }, [query]);
    useEffect(() => {
        if (all_orders_success.result && all_orders_success.result === 'SUCCESS') {
            setOrders(all_orders_success.data.orders);
        }
    }, [all_orders_success]);

    const {
        make_safe_call_success
    } = useSelector((state) => state.safeCall);

    useEffect(() => {
        if (make_safe_call_success && make_safe_call_success.result === 'SUCCESS') {
            toast.success("درخواست تماس امن ارسال شد!");
            dispatch(closeOrderSafeCallModal());
            dispatch(makeSafeCallEmpty());
        }
    },[dispatch, make_safe_call_success]);

    function handleSort() {

    }

    const parseOrdersForTable = () => {
        let ordersParse = []
        orders.map((order,index) => {
            if(order.meta_data !==undefined && order.meta_data !==null && Object.keys(order.meta_data).length !== 0) {
                const metaData= order.meta_data
                const newObj = JSON.parse(metaData)
                const emptySamplerName = {key: "sampler_name", title: "نام پزشک/پرستار", value:'-'}
                const newMetaData = (newObj.sampler_name !== null && newObj.sampler_name!== undefined) ? {...newObj} : {...newObj, sampler_name: emptySamplerName }
                const newOrder = {...order, meta_data:newMetaData}
                ordersParse.push(newOrder)
            } else {
                ordersParse.push(order)
            }
        })
        setNewOrdersParse(ordersParse)
        // dataForExport()
        // checkOrdersExport()
    }
    // const dataForExport = () => {
    //     const newOrderArrayExport = []
    //     newOrdersParse.map((order,index) => {
    //         const samplerName = (order.meta_data.sampler_name !== null && order.meta_data.sampler_name !== undefined) ?  order.meta_data.sampler_name.value : '-'
    //         const newObjExport = {
    //             ...order,
    //             service_title: order.prices.length !== 0 ? order.prices[0].title : '-',
    //             service_count: order.prices.length !== 0 ? order.prices[0].count : '-',
    //             service_worker: samplerName
    //         }
    //         newOrderArrayExport.push(newObjExport)
    //     })
    //     setNewOrdersExport(newOrderArrayExport)
    // }

    const checkOrdersExport = () => {
        const newOrderArrayExport = []
        if(newOrdersParse.length !==0) {
            newOrdersParse.map((order,index) => {
                const samplerName = (order.meta_data.sampler_name !== null && order.meta_data.sampler_name !== undefined) ?  order.meta_data.sampler_name.value : '-'
                const newObjExport = {
                    ...order,
                    service_title: order.prices.length !== 0 ? order.prices[0].title : '-',
                    service_count: order.prices.length !== 0 ? order.prices[0].count : '-',
                    service_worker: samplerName
                }
                newOrderArrayExport.push(newObjExport)
            })
            setNewOrdersExport(newOrderArrayExport)
            return newOrderArrayExport
        }
    }

    useEffect(() => {
        if(vendor_type !== "DRUG"){
            if(orders !== undefined && orders !==null && orders.length !==0) {
                parseOrdersForTable()
            }
        }

    },[orders])

    function handleExport() {
        return (<OrdersListExcel/>)
    }

    function handleChangePerPage(perPage) {
        console.log(perPage)
        setQuery({
            per_page: perPage,
            page: 1,
            query: ""
        })
    }

    function handleChangePage(page) {
        setQuery((prevState) => ({
            ...prevState, page: page, query : (all_orders_success.data === undefined ? "" : all_orders_success.data.query)
        }))
    }

    return (
        <div className="row">
            <div className="col-lg-12 col-md-12 page-header">
                گزارش سفارش‌ها
            </div>
                    <div className="col-lg-12 col-md-12 table-holder">
                        <FilterOrdersComponent
                            search={all_orders_success.data === undefined ? "" : all_orders_success.data.query}
                            page={all_orders_success.data === undefined ? "" : all_orders_success.data.page}
                            perPage={all_orders_success.data === undefined ? "" : all_orders_success.data.per_page}
                        />
                        {
                            all_orders_waiting ? <Loading /> :
                                <>
                                    <DataTable
                                        noHeader={true}
                                        className="main-table shadow-sm"
                                        columns={vendor_type === "HOME_CARE" ? columns : columnsDrug}
                                        data={vendor_type ==="HOME_CARE" ? newOrdersParse : orders}
                                        persistTableHead={true}
                                        keyField='id'
                                        striped={true}
                                        highlightOnHover={true}
                                        pointerOnHover={true}
                                        noDataComponent={<div>موردی یافت نشد!</div>}
                                        pagination
                                        paginationServer
                                        paginationTotalRows={all_orders_success.data ? all_orders_success.data.total : 0}
                                        paginationDefaultPage={all_orders_success.data ? all_orders_success.data.page : 1}
                                        paginationPerPage={all_orders_success.data ? all_orders_success.data.per_page : 10}
                                        onChangePage={handleChangePage}
                                        paginationComponentOptions={{
                                            rowsPerPageText: 'رکورد در صفحه :',
                                            rangeSeparatorText: 'از',
                                            noRowsPerPage: false,
                                            selectAllRowsItem: false,
                                            selectAllRowsItemText: 'همه'
                                        }}
                                        onChangeRowsPerPage={handleChangePerPage}
                                        onSort={handleSort}
                                        sortServer
                                        defaultSortField={'id'}
                                        defaultSortAsc={false}
                                        expandableRows={vendor_type === 'DRUG'}
                                        expandableRowsComponent={<OrderDetailsExpanded/>}
                                        paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 200]}
                                        subHeader={true}
                                        subHeaderComponent={vendor_type ==="HOME_CARE" ? <><HomeCareOrdersListExcel orders={checkOrdersExport}/></> : <><OrdersListExcel orders={orders}/></>}
                                    />
                                </>
                        }
                    </div>
        </div>
    )
}
export default Orders;